import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    color-scheme: light;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    background: ${({ theme }) => theme.colors.background};
  }

  body {
    margin: 0;
    min-width: 320px;
    background:
      radial-gradient(circle at top left, rgba(245, 210, 191, 0.52), transparent 24rem),
      linear-gradient(180deg, #fffaf5 0%, ${({ theme }) => theme.colors.background} 100%);
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.fonts.body};
    line-height: ${({ theme }) => theme.lineHeights.body};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    overflow-x: clip;
  }

  #root {
    min-height: 100vh;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  button,
  input,
  textarea,
  select {
    font: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    overflow-wrap: anywhere;
  }
`;

export default GlobalStyles;
